import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/SistemaContraIncendiosNormalizados/TurbinaEjeVertical/TurbinaEjeVertical1.png';

const TurbinaEjeVertical = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Sistema Contra Incendios - Turbina de Eje Vertical</h2>
      <div className="row align-items-start mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas contra incendio de turbina de eje vertical son una opción eficiente y confiable para 
            sistemas de protección contra incendios, especialmente en aplicaciones donde el suministro de 
            agua proviene de fuentes subterráneas, como pozos o depósitos.
          </p>
          <p className="lead text-justify">
            Estas bombas están diseñadas para ofrecer un rendimiento excepcional en una variedad de condiciones 
            y son adecuadas para edificios comerciales, industriales y residenciales.
          </p>
          <p className="lead text-justify">
            Permite una instalación eficiente en espacios reducidos y facilita el acceso a fuentes de agua subterráneas.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-10">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="turbinaEjeVertical 1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TurbinaEjeVertical;
